import QRCode from "qrcode";

/**
 * Lowest-version QR payload for a block definition: a short uppercase URL
 * (/Q/<PROJECT CODE>/<BLOCK>) that encodes in alphanumeric mode, so modules stay
 * large and scannable when printed at 25–30 mm.
 */
export function blockQrPayload(projectCode, name) {
  const safe = (value) =>
    String(value || "")
      .toUpperCase()
      .replace(/[^A-Z0-9$*+\-./:]/g, (char) =>
        `%${char.charCodeAt(0).toString(16).toUpperCase().padStart(2, "0")}`
      );
  return `${window.location.origin.toUpperCase()}/Q/${safe(projectCode)}/${safe(name)}`;
}

export const QR_OPTIONS = {
  margin: 2,
  errorCorrectionLevel: "L",
  color: { dark: "#000000", light: "#FFFFFF" },
};

export const qrPng = (payload, width = 1200) =>
  QRCode.toDataURL(payload, { ...QR_OPTIONS, width });

export const qrSvg = (payload) =>
  QRCode.toString(payload, { ...QR_OPTIONS, type: "svg", width: 1200 });

export const qrPreview = (payload, width = 180) =>
  QRCode.toDataURL(payload, {
    ...QR_OPTIONS,
    width,
    color: { dark: "#0B1120", light: "#FFFFFF" },
  });

export function saveFile(href, filename) {
  const link = document.createElement("a");
  link.href = href;
  link.download = filename;
  link.click();
}

export const svgDataUrl = (svg) =>
  `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;

/** Block name + panel quantity, e.g. "P01_QR_56.png". */
export const qrFileName = (name, count, ext) => `${name}_QR_${count ?? 0}.${ext}`;

/** Zips every block QR as PNG or SVG and downloads it in one go. */
export async function downloadQrArchive(projectCode, items, format) {
  const { default: JSZip } = await import("jszip");
  const zip = new JSZip();
  for (const { name, count } of items) {
    const payload = blockQrPayload(projectCode, name);
    const file = qrFileName(name, count, format);
    if (format === "svg") {
      zip.file(file, await qrSvg(payload));
    } else {
      const dataUrl = await qrPng(payload);
      zip.file(file, dataUrl.split(",")[1], { base64: true });
    }
  }
  const blob = await zip.generateAsync({ type: "blob" });
  const href = URL.createObjectURL(blob);
  saveFile(href, `${projectCode}_PANEL_QR_${format.toUpperCase()}.zip`);
  setTimeout(() => URL.revokeObjectURL(href), 4000);
}
